import { PassingModeRepository } from '@/store/passing-mode-state/passing-mode-state.repository';

interface IgetPassingModeDeleteObjectProps {
  store?: PassingModeRepository;
  action?: () => void;
  toggleVisiblity?: () => void;
}

export const getPassingModeDeleteObject = ({ store, action, toggleVisiblity }: IgetPassingModeDeleteObjectProps): any => {
  return {
    title: 'settings.passingMode.delete.title',
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.passingMode.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.passingMode.delete.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
